/* istanbul ignore file */
export var MenuItemSectionLabelType;
(function (MenuItemSectionLabelType) {
    MenuItemSectionLabelType["HEADING"] = "HEADING";
    MenuItemSectionLabelType["SUBHEADING"] = "SUBHEADING";
    MenuItemSectionLabelType["LINK"] = "LINK";
    MenuItemSectionLabelType["TEXT"] = "TEXT";
})(MenuItemSectionLabelType || (MenuItemSectionLabelType = {}));
export var MenuItemSectionStyleType;
(function (MenuItemSectionStyleType) {
    MenuItemSectionStyleType["COLUMN"] = "COLUMN";
    MenuItemSectionStyleType["ROW"] = "ROW";
})(MenuItemSectionStyleType || (MenuItemSectionStyleType = {}));
//# sourceMappingURL=global-components-context.js.map